import SectionHero from "components/SectionHero/SectionHero";
import React,{useEffect,useState} from "react";
import { getAllServices} from "services/apiServices";
// import SectionHowItWork from "components/SectionHowItWork/SectionService";
import SectionService from "components/SectionService/SectionService";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import {ToastContainer} from 'react-toastify';
import "../../css/main.css"

function PageHome() {
  const [services, setServices] = useState<any>([]);
  console.log('........................services',services)

  const getServicesData = async () => {
    const response = await getAllServices()
    if (response.data) {
      let tempData: any = [];
      if (response.data.response === "success") {
        response.data.services.forEach((item: any, key: number) => {
          tempData[key] = {
            id: item.id,
            name: item.name,
            discription: item.description,
            image:item.image,
          }
        })
        setServices(tempData)
      }

    }
  }
  useEffect(() => {
    getServicesData()
  }, [])
  return (
    <div className="nc-PageHome relative overflow-hidden">
    <ToastContainer />
      {/* GLASSMOPHIN */}
      <BgGlassmorphism />

      <div className=" relative space-y-24 mb-24 lg:space-y-28 lg:mb-28">
        {/* SECTION HERO */}
        <SectionHero className="pt-10" />

        
        {/* SECTION */}
        <SectionService className="lg:pb-16"/>

        {/* SECTION 1 */}
        {/* <div className="relative py-16">
          <BackgroundSection className="bg-orange-50 dark:bg-black dark:bg-opacity-20 " />
          <SectionSliderNewCategories
            categories={DEMO_CATS_2}
            categoryCardType="card4"
            itemPerRow={4}
            heading="Suggestions for discovery"
            subHeading="Popular places to stay that Chisfis recommends for you"
            sliderStyle="style2"
            uniqueClassName="PageHome_s2"
          />
        </div> */}
       {/*  <SectionGridCategoryBox /> */}
      </div>
    </div>
  );
}

export default PageHome;
